import { NgModule } from '@angular/core';
import { CourseViewComponent } from '@app/main/apps/course-view/course-view.component';
import { SharedModule } from '@shared/shared.module';
import { PlatformIdentifierModule } from '@lngx/platform-identifier';

@NgModule({
  declarations: [
    CourseViewComponent
  ],
  imports: [
    SharedModule,
    PlatformIdentifierModule
  ],
  exports: [CourseViewComponent]
})
export class CourseViewModule { }
